<template>
  <WdsStack align-center gap-sm class="tw-min-w-0">
    <WdsIcon v-if="icon" class="tw-flex-shrink-0" :size="16" :name="icon" />
    <div class="tw-line-clamp-1 tw-break-all">
      <WdsStack gap-xs align-center>
        <button type="button" class="copy-trigger tw-group" :title="$t('Copy')" @click="copyText">
          <WdsText :secondary="secondary" class="tw-line-clamp-1 tw-text-left" :title="title ?? text">
            {{ text }}
          </WdsText>
          <WdsIcon
            v-if="!copied"
            :name="WdsIconNameEnum.COPY"
            :size="14"
            class="tw-flex-shrink-0 tw-invisible group-hover:tw-visible group-focus-visible:tw-visible"
          />
        </button>
        <WdsText v-if="copied" tertiary class="tw-break-normal">{{ $t('Copied!') }}</WdsText>
      </WdsStack>
    </div>
  </WdsStack>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useClipboard } from '@vueuse/core'
import { WdsIcon, WdsIconNameEnum, WdsStack, WdsText } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const props = defineProps<{
  text: string
  icon?: WdsIconNameEnum
  secondary?: boolean
  title?: string
}>()

const { copy } = useClipboard()
const copied = ref(false)

function copyText() {
  copy(props.text)
  copied.value = true
  setTimeout(() => {
    copied.value = false
  }, 1500)
}
</script>

<style scoped lang="scss">
// Reads as text, not a button: the copy affordance only shows on hover or keyboard focus.
.copy-trigger {
  @apply tw-flex tw-items-center tw-gap-1 tw-min-w-0 tw-p-0 tw-border-0 tw-bg-transparent tw-cursor-pointer tw-text-left;
}
</style>
